import { css } from 'styled-components';

const modalStyles = css`
  div.TCPModal__InnerContent.dfs-innerContent {
    font-family: Nunito;
    font-style: normal;
    line-height: normal;
    width: 375px;
    height: 100%;
    padding: 0px;
    padding-top: 24px;
    gap: 16px;
    right: 0;
    left: auto;
    top: 0;
    bottom: 0;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    ${(props) =>
      `
    width: 100%;
    @media ${props.theme.mediaQuery.smallOnly} {
      animation: slide-in-mobile 0.5s forwards;
      border-radius: 12px;
      inset: auto auto 0 auto;
      height: fit-content;
    }
    @keyframes slide-in-mobile {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(5%);
      }
    }
    `}
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 350px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 375px;
    }

    .Modal_Heading {
      color: #1a1a1a;
      font-size: 21px;
      font-weight: 700;
      border: none;
      margin-bottom: 0;
      display: inline;
      ${(props) =>
        `
      margin-left: 20px;
      @media ${props.theme.mediaQuery.medium} {
        margin-left: 16px;
      }
      @media ${props.theme.mediaQuery.smallOnly} {
        margin-left: 33%;
        font-size: ${props.theme.typography.fontSizes.fs16};
      }
      `}
    }

    .desc {
      margin-top: 16px;
      display: flex;
      padding: 8px 0px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 6px;
      background: #edf5fb;
    }
    .desc-content {
      padding: 0px 16px;
    }
    .container {
      padding: 0px 16px 24px 16px;
    }
    .container1 {
      margin: 16px 0px;
    }
    .container2 {
      margin: 24px 0px;
    }
    .sub-msg {
      color: #000;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.56px;
    }
    .main-msg {
      color: #1a1a1a;
      font-size: 16px;
      font-weight: 800;
      letter-spacing: 0.64px;
      .left {
        float: left;
        width: 85%;
      }
      .right {
        float: right;
      }
    }

    .close-modal {
      right: 18px;
      top: 25px;
      ${(props) =>
        `
           @media ${props.theme.mediaQuery.smallOnly} {
            padding: 33px 7px 8px 40px;
            right: 0px;
            top: 12px;
            background-position: 45% 58%;
            background-size: auto;
          }`}
    }
    .blurred-content {
      filter: blur(4px);
      -o-filter: blur(4px);
      -ms-filter: blur(4px);
      -moz-filter: blur(4px);
      -webkit-filter: blur(4px);
    }
    .error-notification {
      background-color: ${(props) => props.theme.colorPalette.gray[300]};
      margin-top: -16px;
    }
  }
  .separator-header {
    height: 1px;
    background: ${(props) => props.theme.colorPalette.gray[500]};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .separator {
    height: 1px;
    background: ${(props) => props.theme.colorPalette.gray[500]};
  }
`;

export default modalStyles;
